import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom'; // Import Link for internal navigation
import './RelatedArticles.css';

const RelatedArticles = ({ relatedArticles }) => {
  const BASE_URL = process.env.REACT_APP_API_URL || 'https://todaylocal.in/api';

  return (
    <div className="related-articles">
      <h2>Related Articles</h2>
      {relatedArticles.length > 0 ? (
        <div className="related-articles-grid">
          {relatedArticles.map((article, index) => (
            <div key={index} className="related-article-card">
              <img
                src={`${BASE_URL}/${article.image}`}
                alt="News"
                style={{ width: '150px', height: '100px', objectFit: 'cover' }} // Adjust size
              />


              <h3 className="related-article-title">
              <a href={`/news/${article.newsId}`}>{article.title}</a>
              </h3>
            </div>
          ))}
        </div>
      ) : (
        <p>No related articles available.</p>
      )}
    </div>
  );
};

RelatedArticles.propTypes = {
  relatedArticles: PropTypes.arrayOf(
    PropTypes.shape({
      _id: PropTypes.string.isRequired,  // Unique identifier for each article
      title: PropTypes.string.isRequired,
      image: PropTypes.string,  // Optional image
    })
  ).isRequired,
};

export default RelatedArticles;
